import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styled from 'styled-components';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';

const Heading = styled.h2`
  font-weight: 500;
`;

const Container = styled.div`
  display: flex;
`;

const InnerContainer = styled.div`
  text-align: ${({ alignText }) => alignText};
  width: ${({ width }) => width};
  padding: 1rem;
`;

const CustomContent = ({ items }) => (
  <PageWrapper>
    <Container>
      {items.map(item => (
        <InnerContainer
          key={item.text || item.title}
          alignment={item.alignment}
          alignText={item.align_text}
          width={item.width}
        >
          {item.title && <Heading>{item.title}</Heading>}
          {item.text &&
            parse(item.text, {
              replace: domNode => {
                if (domNode.type === 'tag' && domNode.name === 'a') {
                  // eslint-disable-next-line no-param-reassign
                  domNode.attribs.rel = 'noopener';
                }
              },
            })}
        </InnerContainer>
      ))}
    </Container>
  </PageWrapper>
);

CustomContent.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string,
      alignment: PropTypes.string,
      align_text: PropTypes.string,
      width: PropTypes.string,
    })
  ).isRequired,
};

export default CustomContent;
